// helix.js — pure spiral maths (no Three.js import, unit-testable)

export const HELIX = {
  R:    6.0,    // horizontal radius (screen X) — how far the loops reach sideways
  Rz:   6,    // depth radius (screen Z) — smaller than R flattens each coil into
                // an elongated, petal-shaped loop instead of a round circle
  H:    6.7,    // vertical rise per full turn — larger pitch so only 3 turns still
                // carry the ribbon from below-screen all the way to above-screen
  rise2: 0.0,   // uniform pitch → steady climb speed as the ribbon winds up the spiral
  step: 0.5,    // angular width of ONE card (edge-to-edge → continuous ribbon)
};

// how many turns the ribbon winds up the spiral across the full scroll
export const TURNS = 3.0;
export const TOTAL_OFFSET = Math.PI * 2 * TURNS;

// point on the helix centre-line at parameter t
export function helixPoint(t, out) {
  const { R, Rz, H, rise2 } = HELIX;
  const u = t / (Math.PI * 2);            // turns
  out.x = R * Math.cos(t);
  out.y = H * u + rise2 * u * u;          // climbs as it winds (drives enter/exit)
  out.z = Rz * Math.sin(t);               // shallow depth → flat, petal-like loops
  return out;
}
